"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderHtmlString = exports.getQueryString = void 0;
var _react = _interopRequireDefault(require("react"));
// 获取url参数
const getQueryString = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = (window.location.search || '').substr(1).match(reg);
  if (r !== null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};
exports.getQueryString = getQueryString;
// 将字符串转换为 React 元素
const renderHtmlString = htmlString => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, htmlString.split('<p>').map((segment, index) => segment.includes('</p>') ? /*#__PURE__*/_react.default.createElement("p", {
    key: index
  }, segment.replace('</p>', '')) : segment));
};
exports.renderHtmlString = renderHtmlString;